import React, { useState } from "react";
import AddButtonSection from './AddButtonSection';
import PrimarySearch from "./primarySearch";
import { Calendar } from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import DownloadButton from "./DownloadButton";
// import '../../assets/styles/buttonWithSearch.scss';

import ArrivedImg from '../../assets/images/arrived-user-image.svg';
export default function ButtonWithSearch({
  children,
  buttons,
  styles,
  searchHeaderLable,
  searchHeaderLeftContent,
  isDownloadButton,
  control,
  isSearchEnabled,
  secoundaryButton,
  placeholder,
  rightChild,
  isCalenderEnabled,
  isButtonEnabledLeft,
  isButtonEnabledRight,
  exportCSV,
  exportExcel,
  exportPdf,
  handleDateChange = () => {},
  ...props
}) {
  const [date, setDate] = useState(null);

  const onCalenderChange = (e) => {
    handleDateChange(e?.value);
    setDate(e?.value);
  };

  const onDownloadClick = () => {};
  return (
    <div className="search-header-holder">
      <div className="search-header-sec">
        <div className="table-sec-calendar">
          <div
            className="align-items-center flex h-2rem mt-3"
            onClick={props?.backButton}
          >
            {props?.backButton && (
              <i className="pi pi-chevron-left text-xs pr-2 cursor-pointer" />
            )}
            {!isCalenderEnabled && searchHeaderLeftContent && (
              <span className="mr-2 flex align-items-center">{searchHeaderLeftContent}</span>
            )}
            {!isCalenderEnabled && <span>{searchHeaderLable}</span>}
          </div>
          {isCalenderEnabled && (
            <FloatLabel>
              <div className="flex align-item-center w-10rem md:w-full ">
                <Calendar
                  id="buttondisplay"
                  appendTo={document.body}
                  inputId="today"
                  placeholder="today"
                  value={date}
                  onChange={onCalenderChange}
                  showIcon
                  panelClassName="custom-calendar-panel"
                />
                {
                  <Button
                    icon="pi pi-times"
                    className="p-button-text p-button-danger ml-3"
                    onClick={() => onCalenderChange(null)}
                    aria-label="Clear Date"
                  />
                }
              </div>
              {!date && <label htmlFor="today">Select Date</label>}
            </FloatLabel>
          )}
          <div className="ml-4 md:ml-0">
            {isButtonEnabledLeft && (
              <AddButtonSection buttons={buttons} disabled={props?.loading} />
            )}
          </div>
          {secoundaryButton && (
            <AddButtonSection
              buttons={secoundaryButton}
              disabled={props?.loading}
            />
          )}
        </div>

        <div className="search-btn-sec">
          <div className="flex ">
            {isDownloadButton && (
              <DownloadButton
                onClick={onDownloadClick}
                exportCSV={exportCSV}
                exportExcel={exportExcel}
                exportPdf={exportPdf}
              />
            )}
          </div>
          <div className="mobile-header-action-group  display-block">
            {isButtonEnabledRight && (
              <AddButtonSection buttons={buttons} disabled={props?.loading} />
            )}

            {isSearchEnabled && (
              <PrimarySearch {...props} placeholder={placeholder} />
            )}
          </div>

          {rightChild ?? ""}
        </div>
      </div>
    </div>
  );
}
